<template>
  <div class="search_container searchArea">
    <el-form
      :inline="true"
      :model="search_data"
      :rules="rules"
      ref="search_data"
      class="demo-form-inline search-form"
    >
      <el-form-item label="">
        <el-input
          v-model="search_data.stdName"
          placeholder="学员姓名"
          @keyup.enter.native="onScreeoutMoney('search_data')"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search_data.stdStatus" placeholder="学员状态">
          <el-option
            v-for="item in statusType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="search"
          @click="onScreeoutMoney('search_data')"
          >筛选</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="success" size="mini" icon="search" @click="refresh()"
          >刷新</el-button
        >
      </el-form-item>

      <el-form-item class="btnRight">
        <el-button
          v-show="roles === 1"
          type="primary"
          size="mini"
          icon="view"
          @click="onBatchDelStudent()"
          :disabled="studentSearchBtnDisabled"
          >批量删除</el-button
        >
        <!-- <el-button type="success" size ="mini" icon="view">导出Elcel</el-button> -->
        <el-button
          v-show="roles === 1"
          type="primary"
          size="mini"
          icon="view"
          @click="onAddStudent()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "searchItem",
  data() {
    return {
      search_data: {
        stdName: "",
        stdStatus: "",
      },
      statusType: [
        { label: "未审核", value: 0 },
        { label: "审核通过", value: 1 },
        { label: "审核失败", value: 2 },
      ],
      rules: {
        name: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapGetters(["studentSearchBtnDisabled", "roles"]),
  },
  created() {},
  methods: {
    refresh() {
      this.search_data = {
        stdName: "",
        stdStatus: "",
      };
      this.$store.commit("SET_STUDENT_SEARCH", this.search_data);
      this.$emit("changePageAndLimit");
      this.$emit("searchList");
    },
    onScreeoutMoney(searchForm) {
      this.$refs[searchForm].validate((valid) => {
        if (valid) {
          this.$store.commit("SET_STUDENT_SEARCH", this.search_data);
          this.$emit("changePageAndLimit");
          this.$emit("searchList");
        }
      });
    },
    onAddStudent() {
      this.$emit("showDialog", "add");
    },
    onBatchDelStudent() {
      //   console.log("batchdelmember");
      this.$emit("batchDelStudent");
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
